<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div v-if="loading" class="text-center">
      <div class="text-center mb-3 justify-content-between">
        <b-spinner variant="primary"></b-spinner>
      </div>
    </div>
    <div v-else class="d-flex flex-column mx-2 mb-5">
      <h2 style="display: flex;">Edit This Modal</h2>
      <div class="d-flex flex-row mt-3">
        <div class="form-group w-50">
          <label class="footerLabels">Popup Title</label>
          <input v-model="popupData.title" class="form-control" placeholder="Enter Title of popup" type="text"/>
        </div>
        <div class="mx-3"></div>
        <div class="w-50 d-flex flex-column">
          <label class="footerLabels">Active</label>
          <select v-model="popupData.active_yn" class="py-2 border border-secondary rounded px-2 ">
            <option value="Y">Active</option>
            <option value="N">Inactive</option>
          </select>
        </div>
      </div>
      <div class="d-flex flex-row">
        <div class="form-group w-50">
          <label class="footerLabels">Publish Date</label>
          <VueDatePicker ref="datepicker" v-model="popupData.publish_date" :format="publishTimeFormat"
                         auto-apply format-locale="bn_BD"/>
          <!--          <input v-model="popupData.title" class="form-control" placeholder="Enter Title of popup" type="text"/>-->
        </div>
        <div class="mx-3"></div>
        <div class="w-50 d-flex flex-column">
          <label class="footerLabels">Expiry Date</label>
          <VueDatePicker ref="datepicker" v-model="popupData.expiry_date" :format="publishTimeFormat"
                         auto-apply format-locale="bn_BD"/>
        </div>
      </div>
      <div class="form-group ">
        <label class="footerLabels">Featured Image</label>
        <div>
          <div class="d-flex justify-content-start">
            <button class="btn btn-light border border-dark" type="button" @click="showModalLogo = true">Add
              Image
            </button>
          </div>
          <div v-if="showModalLogo">
            <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
                 class="modal fade show" role="dialog" style="display: block;"
                 tabindex="-1">
              <div class="modal-dialog modal-xl">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 id="exampleModalFullscreenLabel" class="modal-title h4">Add Media</h5>
                    <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"
                            @click="showModalLogo = false"></button>
                  </div>
                  <div class="modal-body" style="height: 70vh; overflow-y: auto;">
                    <selectLogo :fetchId="popupData.image_id" @logoImg="getLogo"/>
                  </div>
                  <div class="modal-footer">
                    <button class="btn btn-secondary" data-bs-dismiss="modal" type="button"
                            @click="showModalLogo = false">Confirm
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="popupData.image_url != null" class="d-flex flex-row">
            <figure class="figure"
                    style="margin-top: 6px;padding: 6px;background-color: rgb(255, 255, 255);
                  border-radius: 4px;border: 0.5px solid #000;">
              <div>
                <img :src="imageBasePath + popupData.image_url"
                     style="min-height: 100px;max-height: 130px;max-width: 60%;object-fit: contain">
              </div>
            </figure>
            <div>
              <button aria-label="Close" class="mt-2 ms-2 btn-danger px-1" style="padding: 0%;"
                      type="button" @click="closeImage">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="footerLabels">Popup Content</label>
        <div>
          <div class="form-group mt-1">
            <div class="d-flex justify-content-between">
              <div class="d-flex justify-content-start">
                <button class="btn btn-light border border-dark mb-3" type="button"
                        @click="showModalText = true">Add
                  Media
                </button>
              </div>
              <div v-if="showModalText">
                <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
                     class="modal fade show" role="dialog" style="display: block;"
                     tabindex="-1">
                  <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 id="exampleModalFullscreenLabel" class="modal-title h4">Add
                          Media</h5>
                        <button aria-label="Close" class="btn-close" data-bs-dismiss="modal"
                                type="button" @click="showModalText = false"></button>
                      </div>
                      <div class="modal-body" style="height: 70vh; overflow-y: auto;">
                        <show-all-media-component/>
                      </div>
                      <div class="modal-footer">
                        <button class="btn btn-secondary" data-bs-dismiss="modal" type="button"
                                @click="showModalText = false">Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Editor :htmlFetch="popupData.body" @htmlData='setHtmlContent'></Editor>
          </div>
        </div>
      </div>
      <div class="btn btn-primary my-1" style="width: 90px;" type="button" @click="updatePopupModel">Update</div>
    </div>
  </div>
</template>

<script>
import Editor from "@/components/Editor.vue";
import showAllMedia from '@/components/Media/ShowAllMedia.vue';
import popupModalService from '@/services/popup-modal.service';
import Config from '@/config';
import selectLogo from '@/components/Media/SelectLogo.vue';
import {notify} from "@kyvg/vue3-notification";
import VueDatePicker from "@vuepic/vue-datepicker";

export default {
  name: 'PopupModal',
  components: {
    VueDatePicker,
    Editor,
    "show-all-media-component": showAllMedia,
    selectLogo
  },

  mounted() {
    this.popupID = this.$route.params.popupID;
    this.imageBasePath = Config.apiFileBasePath;
    this.getPopupData(this.popupID);
  },
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Theme Options',
          to: '/portal-header'
        }, {
          text: 'PopUp Modal Options',
          href: '/popup-modal'
        },
        {
          text: 'Edit',
          href: '#'
        }
      ],
      popupID: null,
      loading: false,
      showModalText: false,
      showModalLogo: false,
      popupData: {},
      imageBasePath: null,
    }
  },
  methods: {
    setHtmlContent(data) {
      this.popupData.body = data;
    },
    getLogo(data) {
      this.popupData.image_url = data.file_path;
      this.popupData.image_id = data.media_file_id;
    },
    publishTimeFormat(date) {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `${year}-${month}-${day}`;
    },
    async getPopupData(id) {
      try {
        this.loading = true;
        const response = await popupModalService.getPopupData(id);
        this.loading = false;
        if (response.data) {
          this.popupData = response.data;
          // console.log('this.popupData', this.popupData.body);
        }
      } catch (error) {
        this.loading = false;
      }
    },
    closeImage() {
      this.popupData.image_url = null;
      this.popupData.image_id = null;
    },
    validations() {
      if (this.popupData.title == null || this.popupData.title === "") {
        notify({
          type: "error",
          title: "Title can not be empty",
        });
        return false;
      }
      if (this.popupData.expiry_date) {
        let expiryDate = new Date(this.popupData.expiry_date);
        if (expiryDate < new Date()) {
          notify({
            type: "error",
            title: "Please select an expiry date that is after today's date.",
          });
          return false;
        }
      }
      if (this.popupData.publish_date) {
        let publishDate = new Date(this.popupData.publish_date);
        let expiryDate = new Date(this.popupData.expiry_date);
        if (publishDate < new Date()) {
          notify({
            type: "error",
            title: "Please select a publish date that is after today's date.",
          });
          return false;
        }
        if (expiryDate < publishDate) {
          notify({
            type: "error",
            title: "Please select an expiry date that is after the publish date",
          });
          return false;
        }
        this.popupData.active_yn = "N";
      }
      return true;
    },
    async updatePopupModel() {
      try {
        if (!this.validations()) {
          return;
        }
        const requestBody = {
          id: this.popupData.id,
          title: this.popupData.title,
          body: this.popupData.body,
          image_id: this.popupData.image_id,
          image_url: this.popupData.image_url,
          active_yn: this.popupData.active_yn,
          publish_date: this.popupData.publish_date,
          expiry_date: this.popupData.expiry_date,
        };
        this.loading = true;
        const response = await popupModalService.updatePopupData(requestBody);
        this.loading = false;
        let self = this;
        if (response.data) {
          if (response.data.messageCode === 1) {
            notify({
              type: "success",
              title: "Update Menu",
              text: response.data.message,
            });
            self.$router.go(-1);
            // this.getPopupData();
          } else {
            notify({
              type: "error",
              title: "Error",
              text: response.data.message,
            });
          }
        } else {
          notify({
            type: "error",
            title: "Error",
            text: "Save popup data failed",
          });
        }
      } catch (error) {
        this.loading = false;
        notify({
          type: "error",
          title: "Error",
          text: "Save popup data failed",
        });
      }
    }
  }
}
</script>

<style scoped>
.footerLabels {
  font-weight: 700;
  margin-top: 5px;
}
</style>